import React, { Component, Fragment, useEffect,useState } from 'react';
import { Accordion } from 'react-bootstrap'
import { Link } from 'react-router-dom';
import $ from 'jquery';
import { useHistory } from "react-router-dom";
import { checkAccess, FEATURES } from '../../../library/auth'

// window.jquery = window.$ = $
import './sidebar.css'
function Sidebar() {
let AdminPanelAccess=false;
let uploadViewAccess=false;
let databasehelperAccess=false;
let profitabilityDiagnosisAccess=false;
let customMenu=false;
const [showReturnDate,setShowReturnDate]=useState(false);
const [showSaleDate,setShowSaleDate]=useState(false);
const [showFull,setShowFull]=useState(false);

const [showSummary,setShowSummary]=useState(false);

const [showTiered,setShowTiered]=useState(false);

const [showGatewayDecline,setShowGatewayDecline]=useState(false);

const [showHeaterDE,setshowHeaterDE]=useState(false);
const [showHeaterUK,setshowHeaterUK]=useState(false);
const [showHeaterUS,setshowHeaterUS]=useState(false);


let takeRateside=['Akemi Glow',
    'Buzz Bugwatch',
    'Bye Critter',
    'CleanJett',
    'Dermabolt IPL',
    'EliteTac',
    'Extendtecc',
    'Fuel Save Pro',
    'Fuzebug',
    'Inductivv',
    'Ion Pure',
    'Mega MagnaBOOM',
    'Mite Fighter',
    'NetTec Boost',
    'Orthopick',
    'Outsmart',
    'Pest Defence',
    'Popp Chopp',
    'Pro Power Save',
    'RecovStick',
    'Secure Lite Cam',
    'Rival Sports Band',
    'Rival Smart Watch',
    'Bio Band',
    'Vital Fit Track',
    'Buzz Bug Lantern',
    'Ulti Charge'
];
takeRateside=takeRateside.sort();
const [takerateSidebarReportArray,setTakerateSidebarReportArray]=useState(false);


const history = useHistory();
if(localStorage.getItem('isLogin')==="false" || localStorage.getItem('isLogin')==null){
    history.push('/');
    return false;
}
const userdata=JSON.parse(localStorage.getItem('userdata'));

const sidebaretype=userdata.type;

if(sidebaretype=='admin' || sidebaretype=='superadmin' || sidebaretype=='owneradmin'){
    AdminPanelAccess=true;
}
if(sidebaretype=='admin' || sidebaretype=='superadmin' || sidebaretype=='subadmin' || sidebaretype=='databasehelper' || sidebaretype=='owneradmin'){
    uploadViewAccess=true;
}
if(sidebaretype=='databasehelper'){
    databasehelperAccess=true;
}

profitabilityDiagnosisAccess = checkAccess(FEATURES.profit_report);
const productListAccess = checkAccess(FEATURES.products_list);
const revboostReportAccess = checkAccess(FEATURES.revboost_report);
const vipProgramReportAccess = checkAccess(FEATURES.vip_report);
const campaignFulfillmentAccess = checkAccess(FEATURES.campaign_fulfillment);

customMenu = (sidebaretype === 'custom');

function handleClick() {
    history.push("/home");
  }
  function handleShowHideAcc(type){
        if(type=='sale'){
            if(showSaleDate==true){
            setShowSaleDate(false);
            setShowReturnDate(false);
            }else if(showSaleDate==false){
            setShowSaleDate(true);
            setShowReturnDate(false);
            }
        }else if(type=='return'){
            if(showReturnDate==true){
                setShowReturnDate(false);
                setShowSaleDate(false);
                }else if(showReturnDate==false){
                setShowReturnDate(true);
                setShowSaleDate(false);
                }
        }else if(type=='full'){
            
            // setShowFull(true);
            if(showFull==true){
                setShowFull(false);
                setShowSummary(false);
                setShowTiered(false);
            }else if(showFull==false){
                setShowFull(true);
                setShowSummary(false);
                setShowTiered(false);
                
            }
            
        }else if(type=='summary'){

            if(showSummary==true){
                setShowFull(false);
                setShowSummary(false);
                setShowTiered(false);
            }else if(showSummary==false){
                setShowFull(false);
                setShowSummary(true);
                setShowTiered(false);
            }
        }
        else if(type=='tiered'){
            if(showTiered==true){
                setShowTiered(false);
                setShowFull(false);
                setShowSummary(false);
            }else if(showTiered==false){
                setShowTiered(true);
                setShowFull(false);
                setShowSummary(false);
            }
            
            
        }else if(type=='gateway'){
            if(showGatewayDecline==true){
                setShowGatewayDecline(false)
            }else if(showGatewayDecline==false){
                setShowGatewayDecline(true)
            }
            
        }else if(type=='HeaterDE'){
            if(showHeaterDE==true){
            setshowHeaterDE(false);
            setshowHeaterUK(false);
            setshowHeaterUS(false);
            }else if(showHeaterDE==false){
            setshowHeaterDE(true);
            setshowHeaterUK(false);
            setshowHeaterUS(false);
            }
            
        }else if(type=='HeaterUK'){
            if(showHeaterUK==true){
                setshowHeaterDE(false);
                setshowHeaterUK(false);
                setshowHeaterUS(false);
                
            }else if(showHeaterUK==false){
                setshowHeaterUK(true);
                setshowHeaterDE(false);
                setshowHeaterUS(false);
                }

        }else if(type=='HeaterUS'){
            if(showHeaterUS==true){
                setshowHeaterDE(false);
                setshowHeaterUK(false);
                setshowHeaterUS(false);
                
            }else if(showHeaterUS==false){
                setshowHeaterUS(true);
                setshowHeaterUK(false);
                setshowHeaterDE(false);
                }
           
        }
  }
  

// useEffect(()=>{
//     settakerateSidebarReportArray(takeRateside)
// },[])


      
    return (
        <aside id="sidebar-wrapper">
            <div className="sidebar-brand">
            
                <div className='homelogoicon' onClick={handleClick}>
                <h2 >Clearer Data<span>ANALYTICS SIMPLIFIED</span></h2>
                </div>
            </div>
            <div className="sidebar-menu-accordian">
            <Accordion>
                        
                {!customMenu && !databasehelperAccess && 
                    <Accordion.Item eventKey="0">
                        <Accordion.Header>Sales Performance Reports</Accordion.Header>
                        <Accordion.Body>
                            <ul className="list-unstyled sidebar-child-menu">
                                <li className="list-item">
                                    <Link to="/reports/salesperformance/consumption">Consumption Report</Link>
                                </li>
                                <li className="list-item">
                                    <Link to="/reports/salesperformance/affiliateReportingByParentSKU">Affiliate Front-Ends by Parent SKU</Link>
                                </li>
                                <li className="list-item">
                                    <Link to="/reports/salesperformance/AffiliateReview">Affiliate Conversion Tracking and Review</Link>
                                </li>
                                <li className="list-item">
                                    <Link to="/reports/salesperformance/scrubReviewReport">Scrub Percentage Report</Link>
                                </li>

                                
                            </ul>
                        </Accordion.Body>
                    </Accordion.Item>
                    }
                 {(!customMenu ||
                  [
                    'davidteo', 
                    'raj', 
                    'christian',
                    'jon'
                  ].includes(userdata.username))
                  && profitabilityDiagnosisAccess && 
                    <Accordion.Item eventKey="1">
                        <Accordion.Header>Profitability Diagnosis</Accordion.Header>

                        <Accordion.Body>
                        <ul className="list-unstyled sidebar-child-menu" >
                            <li className="list-item">
                                <Link to="/reports/profitsdiagnosis/profitview">Profit View</Link>
                            </li>
                            {productListAccess &&
                            <li className="list-item">
                                <Link to="/reports/profitsdiagnosis/products">Products</Link>
                            </li>
                            }
                        </ul>
                        </Accordion.Body>
                    </Accordion.Item>
                }

                {!customMenu && !databasehelperAccess && 
                    <Accordion.Item eventKey="2">
                        <Accordion.Header>Gateway Performance</Accordion.Header>
                        <Accordion.Body>
                            
                            {/* <ul className="list-unstyled sidebar-child-menu">
                            <li className="list-item">
                                    <Link to="/reports/gatewayBaselineGenerator">Gateway Baseline Generator</Link>
                                </li>
                            </ul> */}
                            <ul className="list-unstyled sidebar-child-menu" >
                            <li className="list-item">
                                    <Link to="/reports/mastergatewayperformance">Master Gateway Performance</Link>
                            </li>
                            <li className="list-item">
                                    <Link to="/reports/DeclineReasonReport">Decline Reason Report</Link>
                            </li>
                            </ul>





                            <h2 class="accordion-header">
                            <button type="button" aria-expanded="true" class="accordion-button" onClick={() =>handleShowHideAcc('gateway')}>Decline Percentage Generator</button>
                            </h2>
                            {showGatewayDecline && (
                            <ul className="list-unstyled sidebar-child-menu" >
                                
                            <li className="list-item">
                                    <Link to="/reports/declinePercentageGenerator/gateway">By Gateway</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/declinePercentageGenerator/campaign_id">By Campaign ID</Link>
                            </li>
                                <li className="list-item">
                                    <Link to="/reports/declinePercentageGenerator/campaign_group">By Campaign Group</Link>
                                   
                                </li>
                                <li className="list-item">
                                    <Link to="/reports/declinePercentageGenerator/offer_id">By Offer ID (C1)</Link>
                                   
                                </li>
                                
                            </ul>
                            )}
                        </Accordion.Body>
                    </Accordion.Item>
                }
                {(!customMenu || 
                  [
                    'jendalumpines',
                    'jobany',
                    'davidteo',
                    'raj',
                    'christian',
                    'jon'
                  ].includes(userdata.username)) &&
                    <Accordion.Item eventKey="11">
                        <Accordion.Header>Take Rate Reports</Accordion.Header>
                        <Accordion.Body>
                           
                            <ul className="list-unstyled sidebar-child-menu" >

                            <h2 class="accordion-header">
                            <button type="button" aria-expanded="true" class="accordion-button" onClick={() =>handleShowHideAcc('HeaterDE')}>Heater - DE</button>
                            </h2>



                            {showHeaterDE && (
                            <ul className="list-unstyled sidebar-child-menu" >
                                
                                <li className="list-item">
                                    <Link to="/reports/TakeRate/allbrandsDE">ALL BRANDS</Link>
                                </li>
                                <li className="list-item">
                                    <Link to="/reports/TakeRate/alphaheaterDE">Alpha Heater</Link>
                                </li>
                                <li className="list-item">
                                    <Link to="/reports/TakeRate/blissheatereu">Bliss Heater</Link>
                                </li>
                                <li className="list-item">
                                    <Link to="/reports/TakeRate/heatloopDE">Heat Loop</Link>
                                </li>
                                <li className="list-item">
                                    <Link to="/reports/TakeRate/heatfinitiDE">Heatfiniti</Link>
                                </li>
                                <li className="list-item">
                                    <Link to="/reports/TakeRate/novaheateu">Nova Heat</Link>
                                </li> 
                                <li className="list-item">
                                    <Link to="/reports/TakeRate/onsenheateu">Onsen Heat</Link>
                                </li>
                                <li className="list-item">
                                    <Link to="/reports/TakeRate/pyrexheatde">Pyrex Heat</Link>
                                </li>
                                <li className="list-item">
                                    <Link to="/reports/TakeRate/smartheatereu">Smart Heater</Link>
                                </li>
                                <li className="list-item">
                                    <Link to="/reports/TakeRate/solheaterDE">Sol Heater</Link>
                                </li>
                                <li className="list-item">
                                    <Link to="/reports/TakeRate/vidaheatDE">Vida Heat</Link>
                                </li>
                                <li className="list-item">
                                    <Link to="/reports/TakeRate/vistaheatDE">Vista Heat</Link>
                                </li>
                                <li className="list-item">
                                    <Link to="/reports/TakeRate/vitalheateu">Vital Heat</Link>
                                </li> 
                                <li className="list-item">
                                    <Link to="/reports/TakeRate/vitalheatproeu">Vital Heat Pro</Link>
                                </li> 
                                <li className="list-item">
                                    <Link to="/reports/TakeRate/warmwaveheateu">Warm Wave Heat</Link>
                                </li> 
                           
                                
                            </ul>
                            )}
                             <h2 class="accordion-header">
                                <button type="button" aria-expanded="true" class="accordion-button" onClick={() =>handleShowHideAcc('HeaterUK')}>Heater - UK</button>
                                </h2>


{showHeaterUK && (
                            <ul className="list-unstyled sidebar-child-menu" >
                                
                                <li className="list-item">
                                    <Link to="/reports/TakeRate/allbrandsUK">ALL BRANDS</Link>
                                </li>
                                <li className="list-item">
                                    <Link to="/reports/TakeRate/alphaheaterUK">Alpha Heater</Link>
                                </li>
                                <li className="list-item">
                                    <Link to="/reports/TakeRate/blissheateruk">Bliss Heater</Link>
                                </li>
                                <li className="list-item">
                                    <Link to="/reports/TakeRate/heatloopUK">Heat Loop</Link>
                                </li>
                                <li className="list-item">
                                    <Link to="/reports/TakeRate/heatfinitiUK">Heatfiniti</Link>
                                </li>
                                <li className="list-item">
                                    <Link to="/reports/TakeRate/novaheatuk">Nova Heat</Link>
                                </li> 
                                <li className="list-item">
                                    <Link to="/reports/TakeRate/onsenheatuk">Onsen Heat</Link>
                                </li>
                                <li className="list-item">
                                    <Link to="/reports/TakeRate/pyrexheatuk">Pyrex Heat</Link>
                                </li>
                                <li className="list-item">
                                    <Link to="/reports/TakeRate/smartheateruk">Smart Heater</Link>
                                </li>
                                <li className="list-item">
                                    <Link to="/reports/TakeRate/solheaterUK">Sol Heater</Link>
                                </li>
                                <li className="list-item">
                                    <Link to="/reports/TakeRate/vidaheatUK">Vida Heat</Link>
                                </li>
                                <li className="list-item">
                                    <Link to="/reports/TakeRate/vistaheatUK">Vista Heat</Link>
                                </li>
                                <li className="list-item">
                                    <Link to="/reports/TakeRate/vitalheatuk">Vital Heat</Link>
                                </li> 
                                <li className="list-item">
                                    <Link to="/reports/TakeRate/vitalheatprouk">Vital Heat Pro</Link>
                                </li> 
                                <li className="list-item">
                                    <Link to="/reports/TakeRate/warmwaveheatuk">Warm Wave Heat</Link>
                                </li> 
                           
                                
                            </ul>
                            )}


<h2 class="accordion-header">
                                <button type="button" aria-expanded="true" class="accordion-button" onClick={() =>handleShowHideAcc('HeaterUS')}>Heater - US</button>
                                </h2>


{showHeaterUS && (
                            <ul className="list-unstyled sidebar-child-menu" >
                                
                                <li className="list-item">
                                    <Link to="/reports/TakeRate/allbrandsUS">ALL BRANDS</Link>
                                </li>
                                <li className="list-item">
                                    <Link to="/reports/TakeRate/alphaheaterUS">Alpha Heater</Link>
                                </li>
                                <li className="list-item">
                                    <Link to="/reports/TakeRate/blissheater">Bliss Heater</Link>
                                </li>
                                <li className="list-item">
                                    <Link to="/reports/TakeRate/heatloopUS">Heat Loop</Link>
                                </li>
                                <li className="list-item">
                                    <Link to="/reports/TakeRate/heatfinitiUS">Heatfiniti</Link>
                                </li>
                                <li className="list-item">
                                    <Link to="/reports/TakeRate/novaheat">Nova Heat</Link>
                                </li> 
                                <li className="list-item">
                                    <Link to="/reports/TakeRate/onsenheat">Onsen Heat</Link>
                                </li>
                                <li className="list-item">
                                    <Link to="/reports/TakeRate/pyrexheat">Pyrex Heat</Link>
                                </li>
                                <li className="list-item">
                                    <Link to="/reports/TakeRate/smartheater">Smart Heater</Link>
                                </li>
                                <li className="list-item">
                                    <Link to="/reports/TakeRate/solheaterUS">Sol Heater</Link>
                                </li>
                                <li className="list-item">
                                    <Link to="/reports/TakeRate/vidaheatUS">Vida Heat</Link>
                                </li>
                                <li className="list-item">
                                    <Link to="/reports/TakeRate/vistaheatUS">Vista Heat</Link>
                                </li>
                                <li className="list-item">
                                    <Link to="/reports/TakeRate/vitalheat">Vital Heat</Link>
                                </li> 
                                <li className="list-item">
                                    <Link to="/reports/TakeRate/vitalheatpro">Vital Heat Pro</Link>
                                </li> 
                                <li className="list-item">
                                    <Link to="/reports/TakeRate/warmwaveheat">Warm Wave Heat</Link>
                                </li> 
                           
                                
                            </ul>
        )}

<li className="list-item">
<span className='sidebarBorder'></span>
</li>
                            
                           


                        



                            <li className="list-item">
                                <Link to="/reports/TakeRate/360brite">360Brite</Link>
                            </li>
                            <li className='list-item'>
                                <Link to='/reports/TakeRate/360brite_sc'>360Brite (VIP)</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/airclearpro">Air Clear Pro</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/akemiglow">Akemi Glow</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/akemiglowwand">Akemi Glow Wand</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/akemirevive">Akemi Revive</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/akemiskin">Akemi Skin</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/allura">Allura</Link>
                            </li>
                            <li className="list-item">
                                    <Link to="/reports/TakeRate/apexpencil">Apex Pencil</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/apexpulsetrack">Apex Pulse Track</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/apexpulsetrackrevboost">Apex Pulse Track (VIP)</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/aquavital">Aqua Vital</Link>
                            </li>
                            <li className="list-item">
                                    <Link to="/reports/TakeRate/astroball">Astro Ball</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/autorescue">Auto Rescue</Link>
                            </li>
                            <li className="list-item">
                                    <Link to="/reports/TakeRate/bioband">Bio Band</Link>
                            </li>
                            <li className='list-item'>
                                <Link to='/reports/TakeRate/bioband_sc'>Bio Band (VIP)</Link>
                            </li>
                            <li className="list-item">
                                    <Link to="/reports/TakeRate/biobandv2">Bio Band V2</Link>
                            </li>

                            <li className="list-item">
                                    <Link to="/reports/TakeRate/blackfalcondrone">Black Falcon Drone</Link>
                            </li>
                            <li className='list-item'>
                                <Link to='/reports/TakeRate/blackfalcondrone_sc'>Black Falcon Drone (VIP)</Link>
                            </li>
                            <li className="list-item">
                                    <Link to="/reports/TakeRate/boltzpro">BoltzPro</Link>
                            </li>
                            <li className='list-item'>
                                <Link to='/reports/TakeRate/boltzpro_sc'>BoltzPro (VIP)</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/breakbolt">Break Bolt</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/breathegreenionizer">Breathe Green Ionizer</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/breathegreennanosparkle">Breathe Green Nano Sparkle</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/breathegreennanosparkle2">Breathe Green Nano Sparkle (2)</Link>
                            </li>
                            <li className='list-item'>
                                <Link to='/reports/TakeRate/breathegreennanosparkle_sc'>Breathe Green Nano Sparkle (VIP)</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/breathguardbuddy">Breath Guard Buddy</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/breathegreenfreshfoam">Breathe Green Fresh Foam</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/breathegreenrefreshspray">Breathe Green Refresh Spray</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/brightstoneguardian">Brightstone Guardian</Link>
                            </li> 
                            <li className="list-item">
                                <Link to="/reports/TakeRate/buzzbashportable">BuzzBash Portable</Link>
                            </li>
                            <li className='list-item'>
                                <Link to='/reports/TakeRate/buzzbashportable_sc'>BuzzBash Portable (VIP)</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/buzzblastpro">Buzz Blast Pro</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/buzzblastprorevboost">Buzz Blast Pro (VIP)</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/buzzbuglantern">Buzz Bug Lantern</Link>
                            </li> 
                            <li className="list-item">
                                <Link to="/reports/TakeRate/buzzbuglanternrevboost">Buzz Bug Lantern (VIP)</Link>
                            </li> 
                            <li className="list-item">
                                <Link to="/reports/TakeRate/buzzheatpro">Buzz Heat Pro</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/buzzbugwatch">Buzz Bugwatch</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/buzzkrush">Buzz Krush</Link>
                            </li> 
                            <li className="list-item">
                                <Link to="/reports/TakeRate/buzzkrushrevboost">Buzz Krush (VIP)</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/buzzoffzapper">Buzz Off Zapper</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/buzzrepelpro">Buzz Repel Pro</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/buzzrepelprolamp">Buzz Repel Pro Lamp</Link>
                            </li>
                            <li className='list-item'>
                                <Link to='/reports/TakeRate/buzzrepelprolamp_sc'>Buzz Repel Pro Lamp (VIP)</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/bugvolt">Bug Volt</Link>
                            </li> 
                            <li className='list-item'>
                                <Link to='/reports/TakeRate/bugvolt_sc'>Bug Volt (VIP)</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/byecritter">Bye Critter</Link>
                            </li>
                            <li className='list-item'>
                                <Link to='/reports/TakeRate/byecritter_sc'>Bye Critter (VIP)</Link>
                            </li>

                            <li className="list-item">
                                <Link to="/reports/TakeRate/camtrack">CamTrack</Link>
                            </li>
                            <li className='list-item'>
                                <Link to='/reports/TakeRate/camtrac_sc'>CamTrac (VIP)</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/carresq">Car ResQ</Link>
                            </li>
                            <li className="list-item">
                                    <Link to="/reports/TakeRate/cleanjett">CleanJett</Link>
                            </li>
                            <li className='list-item'>
                                <Link to='/reports/TakeRate/cleanjett_sc'>CleanJett (VIP)</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/contourglowpro">ContourGlowPro</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/copperrelief">Copper Relief</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/copperrelief2">Copper Relief 2</Link>
                            </li>
                            <li className='list-item'>
                                <Link to='/reports/TakeRate/copperreliefsocks_sc'>Copper Relief (VIP)</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/daysightrevboost">DaySight (VIP)</Link>
                            </li>
                            <li className='list-item'>
                                <Link to='/reports/TakeRate/dentipik_sc'>DentiPik (VIP)</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/dermamicrotone">Derma Micro Tone</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/dermaboltipl">Dermabolt IPL</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/dialoptix">DialOptix</Link>
                            </li>

                            <li className="list-item">
                                    <Link to="/reports/TakeRate/earthtonerbar">Earth Toner Bar</Link>
                            </li>

                            <li className="list-item">
                                    <Link to="/reports/TakeRate/eliteTac">EliteTac</Link>
                            </li>
                            <li className='list-item'>
                                <Link to='/reports/TakeRate/elitetac_sc'>EliteTac (VIP)</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/extendtecc_sc">Extendtecc (VIP)</Link>
                            </li>
                            
                            <li className="list-item">
                                    <Link to="/reports/TakeRate/flyingglowdisc">Flying Glow Disc</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/fuelsavepro">Fuel Save Pro</Link>
                            </li>
                            <li className='list-item'>
                                <Link to='/reports/TakeRate/fuelsavepro_sc'>Fuel Save Pro (VIP)</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/fursweepcollar">Fur Sweep Collar</Link>
                            </li>
                            <li className='list-item'>
                                <Link to='/reports/TakeRate/fursweepcollar_sc'>Fur Sweep Collar (VIP)</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/fuzebug">Fuzebug</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/fuzebugrevboost">Fuzebug (VIP)</Link>
                            </li>

                            <li className="list-item">
                                <Link to="/reports/TakeRate/galaxyflyball">Galaxy Fly Ball</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/grayawaybar">Gray Away Bar</Link>
                            </li>
                            <li className='list-item'>
                                <Link to='/reports/TakeRate/grillsync'>GrillSync</Link>
                            </li>

                            <li className="list-item">
                                <Link to="/reports/TakeRate/hydroblisspro">Hydro Bliss Pro</Link>
                            </li>

                            <li className="list-item">
                                <Link to="/reports/TakeRate/illumigua">IllumiGua</Link>
                            </li>
                            <li className="list-item">
                                    <Link to="/reports/TakeRate/inductivv">Inductivv</Link>
                            </li>
                            <li className='list-item'>
                                <Link to='/reports/TakeRate/inductivv_sc'>Inductivv (VIP)</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/ionpure_sc">Ion Pure (VIP)</Link>
                            </li>

                            <li className='list-item'>
                                <Link to='/reports/TakeRate/kizuspineneck_sc'>Kizu Spine Neck (VIP)</Link>
                            </li>

                            <li className="list-item">
                                    <Link to="/reports/TakeRate/magickick">Magic Kick</Link>
                            </li>
                            <li className="list-item">
                                    <Link to="/reports/TakeRate/megamagnaboom">Mega MagnaBOOM</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/miniguardcam">MiniGuard Cam</Link>
                            </li>
                            <li className='list-item'>
                                <Link to='/reports/TakeRate/miniguardcam_sc'>MiniGuard Cam (VIP)</Link>
                            </li>
                            <li className="list-item">
                                    <Link to="/reports/TakeRate/minipixsnap">Mini Pix Snap</Link>
                            </li>
                            <li className="list-item">
                                    <Link to="/reports/TakeRate/mitefighter">Mite Fighter</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/moodozi">Moodozi</Link>
                            </li>
                            <li className='list-item'>
                                <Link to='/reports/TakeRate/moodozi_sc'>Moodozi (VIP)</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/mozzshield">Mozz Shield</Link>
                            </li>

                            <li className="list-item">
                                    <Link to="/reports/TakeRate/nettecboost">NetTec Boost</Link>
                            </li>
                            <li className='list-item'>
                                <Link to='/reports/TakeRate/novimaxx_sc'>NoviMaxx (VIP)</Link>
                            </li>

                            <li className="list-item">
                                    <Link to="/reports/TakeRate/orthopick">Orthopick</Link>
                            </li>
                            <li className='list-item'>
                                <Link to='/reports/TakeRate/orthopik_sc'>Orthopik (VIP)</Link>
                            </li>

                            <li className='list-item'>
                                <Link to='/reports/TakeRate/orthosparkle_sc'>OrthoSparkle (VIP)</Link>
                            </li>
                            <li className="list-item">
                                    <Link to="/reports/TakeRate/orthosparklede">OrthoSparkle DE</Link>
                            </li>

                            <li className="list-item">
                                    <Link to="/reports/TakeRate/outsmart">Outsmart</Link>
                            </li>
                            <li className='list-item'>
                                <Link to='/reports/TakeRate/outsmart_sc'>Outsmart (VIP)</Link>
                            </li>

                            <li className="list-item">
                                    <Link to="/reports/TakeRate/pestdefence">Pest Defence</Link>
                            </li>
                            <li className='list-item'>
                                <Link to='/reports/TakeRate/pestdefence_sc'>Pest Defence (VIP)</Link>
                            </li>
                            <li className="list-item">
                                    <Link to="/reports/TakeRate/pestdefencede">Pest Defence DE</Link>
                            </li>
                            <li className='list-item'>
                                <Link to='/reports/TakeRate/pestsprotect_sc'>Pests Protect (VIP)</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/pixielenspro">PixieLens Pro</Link>
                            </li>
                            <li className="list-item">
                                    <Link to="/reports/TakeRate/poppchopp">Popp Chopp</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/powerblastplus">Power Blast Plus</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/propowersave_sc">Pro Power Save (VIP)</Link>
                            </li>
                            <li className="list-item">
                                    <Link to="/reports/TakeRate/propowersavede">Pro Power Save DE</Link>
                            </li>
                            <li className="list-item">
                                    <Link to="/reports/TakeRate/propowersaveuk">Pro Power Save UK</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/propulseox">Pro Pulse Ox</Link>
                            </li>
                            <li className="list-item">
                                    <Link to="/reports/TakeRate/proxtremecam">Pro Xtreme Cam</Link>
                            </li>
                            <li className='list-item'>
                                <Link to='/reports/TakeRate/proxtremecam_sc'>Pro Xtreme Cam (VIP)</Link>
                            </li>
                            <li className="list-item">
                                    <Link to="/reports/TakeRate/pulsebandpro">Pulse Band Pro</Link>
                            </li>
                            <li className='list-item'>
                                <Link to='/reports/TakeRate/pulsebandpro_sc'>Pulse Band Pro (VIP)</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/pyrobusterpro">Pyro Buster Pro</Link>
                            </li>

                            <li className="list-item">
                                    <Link to="/reports/TakeRate/quantumlight">Quantum Light</Link>
                            </li>

                            
                            <li className="list-item">
                                    <Link to="/reports/TakeRate/recovstick">RecovStick US</Link>
                            </li>
                            <li className="list-item">
                                    <Link to="/reports/TakeRate/recovstickde">RecovStick DE</Link>
                            </li>
                            <li className="list-item">
                                    <Link to="/reports/TakeRate/recovstickdeold">RecovStick DE old</Link>
                            </li>
                            <li className="list-item">
                                    <Link to="/reports/TakeRate/recovstickuk">RecovStick UK</Link>
                            </li>
                            <li className='list-item'>
                                <Link to='/reports/TakeRate/remoteracerz'>Remote Racerz</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/repelraylamp">Repel Ray Lamp</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/repelraypro">Repel Ray Pro</Link>
                            </li>
                            <li className="list-item">
                                    <Link to="/reports/TakeRate/rivalbuds">Rival Buds</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/rivalrepel">Rival Repel</Link>
                            </li>
                            <li className="list-item">
                                    <Link to="/reports/TakeRate/rivalsmartwatch">Rival Smart Watch</Link>
                            </li>
                            <li className='list-item'>
                                <Link to='/reports/TakeRate/rivalsmartwatch_sc'>Rival Smart Watch (VIP)</Link>
                            </li>
                            <li className="list-item">
                                    <Link to="/reports/TakeRate/rivalsportsband">Rival Sports Band</Link>
                            </li>
                            <li className='list-item'>
                                <Link to='/reports/TakeRate/rivalsportsband_sc'>Rival Sports Band (VIP)</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/rivaltac">Rival Tac</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/rivalzapper">Rival Zapper</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/rotatogrip">Rotato Grip</Link>
                            </li>
                            <li className='list-item'>
                                <Link to='/reports/TakeRate/rotatogrip_sc'>Rotato Grip (VIP)</Link>
                            </li>

                            <li className='list-item'>
                                <Link to='/reports/TakeRate/sanipik_sc'>SaniPik (VIP)</Link>
                            </li>
                            <li className='list-item'>
                                <Link to='/reports/TakeRate/saniwhite_sc'>SaniWHITE (VIP)</Link>
                            </li>
                            <li className="list-item">
                                    <Link to="/reports/TakeRate/securelitecam">Secure Lite Cam</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/skyhawkdrone">Sky Hawk Drone</Link>
                            </li>
                            <li className="list-item">
                                    <Link to="/reports/TakeRate/sleepease">Sleep Ease</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/soothely">Soothely</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/soundrevv">SoundRevv</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/soundrevvrevboost">SoundRevv (VIP)</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/spinviewpro">SpinView Pro</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/sterilairuv">SterilAir UV</Link>
                            </li>
                            <li className='list-item'>
                                <Link to='/reports/TakeRate/suresleep'>Sure Sleep</Link>
                            </li>
                            <li className='list-item'>
                                <Link to='/reports/TakeRate/swiveldock'>Swivel Dock</Link>
                            </li>

                            <li className="list-item">
                                <Link to="/reports/TakeRate/tacticalcarlock">Tactical Car Lock</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/tacticalchainsaw">Tactical Chainsaw</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/tacticalheadlight">Tactical Headlight</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/tetrabeam">TetraBeam</Link>
                            </li>
                            <li className='list-item'>
                                <Link to='/reports/TakeRate/tetrabeam_sc'>TetraBeam (VIP)</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/trekguardsurvivalstick">TrekGuard Survival Stick</Link>
                            </li>

                            <li className="list-item">
                                    <Link to="/reports/TakeRate/ulticharge">Ulti-Charge</Link>
                            </li> 
                            <li className='list-item'>
                                <Link to='/reports/TakeRate/ulticharge_sc'>Ulti-Charge (VIP)</Link>
                            </li>

                            <li className="list-item">
                                    <Link to="/reports/TakeRate/vervevroomrccar">VerveVroom RC Car</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/vishift">Vi-Shift</Link>
                            </li>
                            <li className="list-item">
                                    <Link to="/reports/TakeRate/vitalbrushpro">Vital Brush Pro</Link>
                            </li>
                            <li className="list-item">
                                    <Link to="/reports/TakeRate/vitaldashcam">Vital Dashcam</Link>
                            </li>
                            <li className='list-item'>
                                <Link to='/reports/TakeRate/vitaldashcam_sc'>Vital Dashcam (VIP)</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/vitalearbuds">Vital Earbuds</Link>
                            </li> 
                            <li className='list-item'>
                                <Link to='/reports/TakeRate/vitalearbuds_sc'>Vital Earbuds (VIP)</Link>
                            </li>
                            <li className='list-item'>
                                <Link to='/reports/TakeRate/vitalfittrack_sc'>Vital Fit Track (VIP)</Link>
                            </li>
                            <li className="list-item">
                                    <Link to="/reports/TakeRate/vitalflexcore">Vital Flex Core</Link>
                            </li> 
                            <li className='list-item'>
                                <Link to='/reports/TakeRate/vitalflexcore_sc'>Vital Flex Core (VIP)</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/vitaltacflashlights">VitalTac Flashlights</Link>
                            </li>
                            <li className='list-item'>
                                <Link to='/reports/TakeRate/vitaltac_sc'>VitalTac (VIP)</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/vitarevivecserum">VitaRevive C-Serum</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/TakeRate/wifiguardcam">WifiGuard Cam</Link>
                            </li>
                
                            </ul>
                        </Accordion.Body>
                    </Accordion.Item>
                }


                {!customMenu && !databasehelperAccess && 
                    <Accordion.Item eventKey="3">
                        <Accordion.Header>Chargeback/Refund Report</Accordion.Header>

                        <Accordion.Body>
                            
                            <h2 class="accordion-header">
                            <button type="button" aria-expanded="true" class="accordion-button" onClick={() =>handleShowHideAcc('sale')}>By Sale Date</button>
                            </h2>
                            {showSaleDate && (
                            <ul className="list-unstyled sidebar-child-menu" >
                                
                        

                                
                            <li className="list-item">
                            <Link to="/reports/chargebackRefundSale/ProductCategory">By Product Category</Link>
                            </li>
                            <li className="list-item">
                            <Link to="/reports/chargebackRefundSale/AFFID">By AFFID</Link>
                            </li>
                            <li className="list-item">
                            <Link to="/reports/chargebackRefundSale/C1">By C1</Link>
                            </li>
                                
                            </ul>
                            )}
                           
                            <h2 class="accordion-header">
                            <button type="button" aria-expanded="true" class="accordion-button" onClick={() =>handleShowHideAcc('return')}>By Return Date</button>
                            </h2>
                            {showReturnDate && (  
                            <ul className="list-unstyled sidebar-child-menu">
                              
                               <li className="list-item">
                                    <Link to="/reports/chargebackRefundReturn/ProductCategory">By Product Category</Link>
                                </li>
                                <li className="list-item">
                                    <Link to="/reports/chargebackRefundReturn/AFFID">By AFFID</Link>
                                </li>
                                <li className="list-item">
                                    <Link to="/reports/chargebackRefundReturn/C1">By C1</Link>
                                </li>
                            </ul>
                           
                            )}
                        </Accordion.Body>
                       
                    </Accordion.Item>
                }
                {((!customMenu && !databasehelperAccess) || 
                  (customMenu && ['jendalumpines'].includes(userdata.username)))
                  &&
                    <Accordion.Item eventKey="4">
                        <Accordion.Header>Shipping Reports</Accordion.Header>
                        <Accordion.Body>
                            <ul className="list-unstyled sidebar-child-menu">
                                <li className="list-item">
                                    <Link to="/reports/shippingreports/firstmilecostanalysis"> FirstMile Cost Analysis</Link>
                                </li>
                                <li className="list-item">
                                    <Link to="/reports/shippingreports/shipcostbyoffer">Ship Cost by Offer</Link>
                                </li>
                                <li className="list-item">
                                    <Link to="/reports/shippingreports/shipcostpickupdate">Ship Cost by Pickup Date</Link>
                                </li>
                                {campaignFulfillmentAccess &&
                                <li className="list-item">
                                    <Link to="/reports/shippingreports/offerff">Campaign Fulfillment</Link>
                                </li>}
                            </ul>
                        </Accordion.Body>
                    </Accordion.Item>
                }

{/* 
                {(!customMenu ||
                  [
                    'davidteo', 
                    'raj', 
                    'christian',
                    'jon'
                  ].includes(userdata.username))
                  && revboostReportAccess && 
                    <Accordion.Item eventKey="16">
                        <Accordion.Header>Revboost</Accordion.Header>
                        <Accordion.Body>
                        <ul className="list-unstyled sidebar-child-menu" >
                            <li className="list-item">
                                <Link to="/reports/profitsdiagnosis/revboost">Revboost Revenue</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/profitsdiagnosis/revboostretention">Revboost CVR & Retention</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/revboost/revboostchargebackdetail">Revboost Chargeback Detail</Link>
                            </li>
                        </ul>
                        </Accordion.Body>
                    </Accordion.Item>
                }
 */}
 
                {(!customMenu ||
                  [
                    'jon'
                  ].includes(userdata.username)) 
                  && vipProgramReportAccess && 
                    <Accordion.Item eventKey="17">
                        <Accordion.Header>VIP</Accordion.Header>
                        <Accordion.Body>
                        <ul className="list-unstyled sidebar-child-menu" >
                            <li className="list-item">
                                <Link to="/reports/vip/revenue">VIP Revenue</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/reports/vip/retention">VIP CVR & Retention</Link>
                            </li>
                        </ul>
                        </Accordion.Body>
                    </Accordion.Item>
                }

                {!customMenu && !databasehelperAccess && 
                    <Accordion.Item eventKey="6">
                        <Accordion.Header>Customer Service Report</Accordion.Header>
                        <Accordion.Body>
                            <ul className="list-unstyled sidebar-child-menu">
                                <li className="list-item">
                                    <Link to="/reports/CustomerServiceReports/NetworkvsKlaviyoReport">Network vs Klaviyo Report</Link>
                                </li>
                                <li className="list-item">
                                    <Link to="/reports/CustomerServiceReports/csnoteswithoutcodes">CS Notes Without Codes</Link>
                                </li>

                                
                                
                            </ul>
                        </Accordion.Body>
                    </Accordion.Item>

                }             

                {!customMenu && uploadViewAccess && 

                    <Accordion.Item eventKey="7">
                        <Accordion.Header>Database Tables - Upload</Accordion.Header>
                        <Accordion.Body>
                            <ul className="list-unstyled sidebar-child-menu">
                            <li className="list-item">
                                    <Link to="/uploadCB911">CB911</Link>
                                </li>
                                <li className="list-item">
                                    <Link to="/uploadCscodes">CS_CODES</Link>
                                </li>
                                <li className="list-item">
                                    <Link to="/uploadCsnotes">CS_NOTES</Link>
                                </li>
                                <li className="list-item">
                                    <Link to="/uploadFirstmile">FIRSTMILE</Link>
                                </li>
{/*                              
                                <li className="list-item">
                                    <Link to="/uploadGateways">GATEWAYS</Link>
                                </li>
*/}
                                <li className="list-item">
                                    <Link to="/uploadShippingRates">SHIPPING_RATES</Link>
                                </li>
{/*                              
                                <li className="list-item">
                                    <Link to="/uploadTransactions">TRANSACTIONS</Link>
                                </li>
                                <li className="list-item">
                                    <Link to="/uploadProducts">PRODUCTS</Link>
                                </li>
                                
                                <li className="list-item">
                                    <Link to="/uploadCampaigns">CAMPAIGNS</Link>
                                </li>
*/}
                                <li className="list-item">
                                    <Link to="/uploadEverflow">EVERFLOW</Link>
                                </li>
                                <li className="list-item">
                                    <Link to="/uploadAffiliates">AFFILIATES</Link>
                                </li>
                                <li className="list-item">
                                    <Link to="/uploadShipstation">SHIPSTATION</Link>
                                </li>

                                
                                
                                
                            </ul>
                        </Accordion.Body>
                    </Accordion.Item>

                }

                {!customMenu && uploadViewAccess && 
                    <Accordion.Item eventKey="8">
                        <Accordion.Header>Database Tables - View</Accordion.Header>
                        <Accordion.Body>
                            <ul className="list-unstyled sidebar-child-menu">
                                <li className="list-item">
                                    <Link to="/viewCB911">CB911</Link>
                                </li>
                                <li className="list-item">
                                    <Link to="/viewcscodes">CS_CODES</Link>
                                </li>
                                <li className="list-item">
                                    <Link to="/viewcsnotes">CS_NOTES</Link>
                                </li>
                                <li className="list-item">
                                    <Link to="/viewFirstmile">FIRSTMILE</Link>
                                </li>
                                <li className="list-item">
                                    <Link to="/viewGateways">GATEWAYS</Link>
                                </li>
                                <li className="list-item">
                                    <Link to="/viewShippingRates">SHIPPING_RATES</Link>
                                </li>
                                <li className="list-item">
                                    <Link to="/viewTransactions">TRANSACTIONS</Link>
                                </li>
                                <li className="list-item">
                                    <Link to="/viewProducts">PRODUCTS</Link>
                                </li>
                               
                              
                                <li className="list-item">
                                    <Link to="/viewCampaigns">CAMPAIGNS</Link>
                                </li>
                                <li className="list-item">
                                    <Link to="/viewEverflow">EVERFLOW</Link>
                                </li>

                                <li className="list-item">
                                    <Link to="/viewAffiliates">AFFILIATES</Link>
                                </li>
                                
                                <li className="list-item">
                                    <Link to="/viewShipstation">SHIPSTATION</Link>
                                </li>
                              
                                
                            </ul>
                        </Accordion.Body>
                    </Accordion.Item>

                }

                {!customMenu && uploadViewAccess && 
                    <Accordion.Item eventKey="10">
                        <Accordion.Header>Database Tables - Export</Accordion.Header>
                        <Accordion.Body>
                            <ul className="list-unstyled sidebar-child-menu">
                                <li className="list-item">
                                    <Link to="/download/cb911">CB911</Link>
                                </li>
                                <li className="list-item">
                                    <Link to="/download/cs_codes">CS_CODES</Link>
                                </li>
                                <li className="list-item">
                                    <Link to="/download/cs_notes">CS_NOTES</Link>
                                </li>
                                <li className="list-item">
                                    <Link to="/download/firstmile">FIRSTMILE</Link>
                                </li>
                            
                                <li className="list-item">
                                    <Link to="/download/gateways">GATEWAYS</Link>
                                </li>
                                <li className="list-item">
                                    <Link to="/download/shipping_rates">SHIPPING_RATES</Link>
                                </li>
                                <li className="list-item">
                                    <Link to="/download/transactions">TRANSACTIONS</Link>
                                </li>
                                <li className="list-item">
                                    <Link to="/download/products">PRODUCTS</Link>
                                </li>
                               
                              
                                <li className="list-item">
                                    <Link to="/download/campaigns">CAMPAIGNS</Link>
                                </li>
                                <li className="list-item">
                                    <Link to="/download/everflow">EVERFLOW</Link>
                                </li>

                                <li className="list-item">
                                    <Link to="/download/affiliates">AFFILIATES</Link>
                                </li>
                                
                              
                                
                            </ul>
                        </Accordion.Body>
                    </Accordion.Item>

                }

                   
                {!customMenu && AdminPanelAccess && 
                  
                    <Accordion.Item eventKey="9">
                        <Accordion.Header>Admin Panels</Accordion.Header>
                        <Accordion.Body>
                            <ul className="list-unstyled sidebar-child-menu">
                                <li className="list-item">
                                    <Link to="/users">Users</Link>
                                </li>
                                
                            </ul>
                        </Accordion.Body>
                    </Accordion.Item>
                }


                  
                {customMenu && userdata && <>
                {['revboost'].includes(userdata.username) && <>
                    {/* <Accordion.Item>
                        <Accordion.Header>Reports</Accordion.Header>
                        <Accordion.Body>
                            <ul className="list-unstyled sidebar-child-menu">
                                {profitabilityDiagnosisAccess &&
                                <li className="list-item">
                                    <Link to="/reports/profitsdiagnosis/profitview">Profit View</Link>
                                </li>
                                }
                                {revboostReportAccess && <>
                                <li className="list-item">
                                    <Link to="/reports/profitsdiagnosis/revboost">Revboost Revenue</Link>
                                </li>
                                <li className="list-item">
                                    <Link to="/reports/profitsdiagnosis/revboostretention">Revboost CVR & Retention</Link>
                                </li>
                                <li className="list-item">
                                    <Link to="/reports/revboost/revboostchargebackdetail">Revboost Chargeback Detail</Link>
                                </li>
                                </>}
                                <li className="list-item">
                                    <Link to="/reports/TakeRate/extendteccrevboostspecial">Extendtecc</Link>
                                </li>
                                <li className="list-item">
                                    <Link to="/reports/TakeRate/ionpurerevboostspecial">Ion Pure</Link>
                                </li>
                                <li className="list-item">
                                    <Link to="/reports/TakeRate/propowersaverevboostspecial">Pro Power Save</Link>
                                </li>
                            </ul>
                        </Accordion.Body>
                    </Accordion.Item> */}
                </> }                
                
                {['jendalumpines'].includes(userdata.username) && <>
                    <Accordion.Item eventKey="0">
                        <Accordion.Header>Sales Performance Reports</Accordion.Header>
                        <Accordion.Body>
                            <ul className="list-unstyled sidebar-child-menu">
                                <li className="list-item">
                                    <Link to="/reports/salesperformance/consumption">Consumption Report</Link>
                                </li>
                            </ul>
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="3">
                        <Accordion.Header>Database Tables - Upload</Accordion.Header>
                        <Accordion.Body>
                            <ul className="list-unstyled sidebar-child-menu">
                                <li className="list-item">
                                    <Link to="/uploadFirstmile">FIRSTMILE</Link>
                                </li>
                            </ul>
                        </Accordion.Body>
                    </Accordion.Item>
                </> }                
                </> }
            </Accordion>
            </div>
        </aside>
    )
}

export default Sidebar